"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const types_1 = require("../../types");
const MAX_HEIGHT = 1024;
/* max 90% height */
const MAZ_HEIGHT_PERCENT = 0.85;
const _convertToRatioNum = (aspectRatio) => {
    let ratioNum;
    if (aspectRatio === null || aspectRatio === void 0 ? void 0 : aspectRatio.includes('/')) {
        const [width, height] = aspectRatio.split('/');
        ratioNum = parseInt(width, 10) / parseInt(height, 10);
    }
    else {
        ratioNum = parseInt(aspectRatio, 10);
    }
    return ratioNum;
};
const useDimensions = () => {
    const [width, setWidth] = react_1.useState((window.innerWidth * MAZ_HEIGHT_PERCENT));
    const [height, setHeight] = react_1.useState((window.innerHeight * MAZ_HEIGHT_PERCENT));
    const setHeightAndWidth = (dimension, staticHeightAdjust) => {
        if (dimension === types_1.FULL_SCREEN) {
            setHeight('100%');
            setWidth('100%');
        }
        else {
            const rationNum = _convertToRatioNum(dimension);
            let newHeight = (window.innerHeight > MAX_HEIGHT ? MAX_HEIGHT : window.innerHeight) * MAZ_HEIGHT_PERCENT;
            let newWidth = newHeight * rationNum;
            if (newWidth > window.innerWidth * MAZ_HEIGHT_PERCENT) {
                newWidth = window.innerWidth * MAZ_HEIGHT_PERCENT;
                newHeight = newWidth / rationNum;
            }
            newHeight -= staticHeightAdjust || 0;
            setHeight(Math.floor(newHeight));
            setWidth(Math.floor(newWidth));
        }
    };
    return [{ height, width }, setHeightAndWidth];
};
exports.default = useDimensions;
